<template>
  <div class="quote-grid">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-12 col-12" v-for="item in quotes" :key="item.id">
          <quote-block-for-admin :quote="item" v-on:remove-quote="onRemoveQuote($event, item)"></quote-block-for-admin>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import QuoteBlockForAdmin from '@/components/Single/QuoteBlockForAdmin'
  import firestore from '../../firebaseInit';

  export default {
    name: 'QuoteGrid',
    components: {
      QuoteBlockForAdmin
    },
    data: function () {
      return {
        quotes: []
      }
    },
    created() {
      firestore.collection('quotes').get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'id': doc.data().id,
            'content': doc.data().content,
            'hearts': doc.data().hearts,
            'author': doc.data().author,
            'contributor': doc.data().contributor,
            'socialUrl': doc.data().socialUrl
          }
          console.log(data)
          this.quotes.push(data)
        })
      })
    },
    methods: {
      onRemoveQuote: function (event, item) {
        console.log(item)
        //update heart count with firebase api 
        firestore.collection('quotes').where('id', '==', item.id).get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              doc.ref.delete()
            })
          }).then(() => {
            console.log('successfully deleted!')
            this.quotes = this.quotes.filter( quote => quote !== item)
          })
          .catch(error => console.error(error))
      }
    }
  }
</script>